<template>
	<div class="container-my-debits">
		<template>
			<div class="header-debits">
				<i :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }" @click="$router.push({ name: 'AccordionTabs' })" class="fas fa-times" />
			</div>
			<h3 :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }">Meus Acordos</h3>
			<p v-if="acordos && acordos.length > 0" class="message-sub">Você possui {{ acordos.length }} {{ acordos.length === 1 ? "acordo" : "acordos" }}</p>
			<p v-else class="message-sub">Você ainda não possui nenhum acordo</p>
			<AgreementCard v-for="acordo in acordos" :key="acordo.aco_codigo" :acordo="acordo" />
		</template>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Template from "../../admin/Template";
import AgreementCard from "./components/AgreementCard";
export default {
	name: "MyAgreements",
	components: { AgreementCard, Template },
	data() {
		return {};
	},
	async mounted() {
		this.SET_LOADING(true);
		this.SET_LOADING_MESSAGE("Carregando os seus acordos.");
		if (this.empresas && this.empresas.length > 0) {
			let negociacoes = [];
			let promises = [];
			this.empresas.forEach((empresa) => {
				promises.push(
					this.action_getAcordos({
						cpfCnpj: this.cpfCnpj,
						emp_codigo: empresa.emp_codigo
					})
						.then((response) => {
							if (response.length >= 1) {
								response.forEach((acordo) => {
									negociacoes.push({
										...empresa,
										...acordo
									});
								});
							} else if (response.retorno) {
								response.dados.forEach((dado) => {
									dado.acordos.forEach((acordo) => {
										negociacoes.push({
											...empresa,
											...acordo
										});
									});
								});
							}
						})
						.catch((error) => {
							return error;
						})
				);
			});
			await Promise.all(promises);
			this.SET_ACORDOS(negociacoes);
			this.SET_LOADING_MESSAGE("");
			this.SET_LOADING(false);
			window.fbq("trackCustom", "Meus Acordos");
		}
	},
	methods: {
		...mapMutations(["SET_ACORDOS", "SET_LOADING", "SET_LOADING_MESSAGE"]),
		...mapActions(["action_getAcordos"])
	},
	computed: {
		...mapState({
			empresas: (state) => state.empresas,
			acordos: (state) => state.acordos,
			cpfCnpj: (state) => state.cpfCnpj,
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			empresas: (state) => state.empresas
		})
	}
};
</script>

<style scoped>
.container-my-debits {
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #f3f5f9;
	flex: 1;
	box-sizing: border-box;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	color: #031b4e;
	font-family: Montserrat-Bold;
	font-size: 28px;
	margin-bottom: 10px;
	text-transform: uppercase;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}

.message-sub {
	color: #5b6987;
	font-size: 14px;
	margin-bottom: 10px;
}
</style>
